export const ADDRESS_SEARCH_URL = 'https://www.google.com.br/maps/search/';

export const getGoogleMapsUrlByAddress = (address: string) => {
  const encodedAddress = encodeURI(address);
  return `${ADDRESS_SEARCH_URL}${encodedAddress}`;
};
